import { Moment } from './constructor';

export function clone() {
    return new Moment(this);
}



//////////////////
// WEBPACK FOOTER
// D:/Projects/MDA/schoolofmusic-ucla/web/app/themes/ucla/node_modules/moment/src/lib/moment/clone.js
// module id = 331
// module chunks = 0